import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class ScreenSaverService {

  httpOptions = {
    headers:new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  formDataHttpOptions = {
    headers:new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  constructor(private http: HttpClient, private constant: Constant) {

  }

  getAll(): Observable<any> {
    return this.http.get<any>(this.constant.API_DOMAIN + '/api/v1/screen-saver', this.httpOptions);
  }

  create(req): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/screen-saver', req,
    this.formDataHttpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  update(req): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/screen-saver-update', req,
    this.formDataHttpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  updateOrder(orders): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/screen-saver-update-order', { orders },
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  delete(id): Observable<any> {
    return this.http.delete<any>(this.constant.API_DOMAIN + '/api/v1/screen-saver/' + id,
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Error handling
  handleError(e) {
  console.log(e);
  if(e.error && e.error.message) {
    return throwError(e.error.message);
  }
  return throwError('');
  }
}